
import translations from './translation.json'
import polyglotI18nProvider from 'ra-i18n-polyglot';
import englishMessages from 'ra-language-english';

const i18nProvider = polyglotI18nProvider(locale => ({...englishMessages, ...translations['en']}), 'en', { allowMissing: true });
export default i18nProvider;